import { defineComponent } from 'vue';
export default defineComponent({
    name: 'product-description-entry',
    props: {
        title: String,
        content: String,
    },
    data() {
        return {
            expanded: false,
        };
    },
    methods: {
        toggleExpansion() {
            this.expanded = !this.expanded;
        },
    },
});
